import { AppState } from "../../../redux-configuration/AppState";
import { Order } from "../../domain/entities/order";

export const loadingOrderSelector = (appState: AppState): boolean => appState.clickCollect.loadOrder.loading
export const errorLoadingOrderSelector = (appState: AppState): string | undefined => appState.clickCollect.loadOrder.error
export const orderSelector = (appState: AppState): Order | null => appState.clickCollect.loadOrder.order
